import {
  FILTERS_SUCCESS,
  FILTERS_FAILURE,
  FILTERS_REQUEST,
} from '../actions/filters';

const initialState = {
  byId: {},
  allIds: [],
  isFetching: false,
  fetchError: null,
};

export default (state = initialState, action) => {
  const { payload = {} } = action;
  const { error, filters } = payload;

  switch (action.type) {
    case FILTERS_REQUEST:
      return { ...state, isFetching: true, fetchError: null };
    case FILTERS_FAILURE:
      return { ...initialState, fetchError: error };
    case FILTERS_SUCCESS:
      return {
        ...state,
        allIds: Object.keys(filters),
        byId: { ...filters },
        isFetching: false,
        fetchError: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/filters.js